<template>
  <section class="form-contact1">
    <h2 class="text-center text-orange" v-if="title" v-once>{{ title }}</h2>
    <div class="form-contact-content">
      <form @submit.prevent="submit" ref="formReport" id="form-contact" :key="componentKey">
        <slot name="form-top"></slot>
        
        <field
          has-border
          is-small
          placeholder="Nome (Opcional)"
          :input="{ type: 'text', name: 'Nome' }"
        />

        <field
          has-border
          is-small
          placeholder="E-mail (Opcional)"
          :input="{ type: 'email', name: 'Email' }"
        />

        <field
          has-border
          is-small
          placeholder="Telefone (Opcional)"
          :input="{ type: 'tel', name: 'Telefone'}"
        />

        <field has-border is-small placeholder="Mensagem (Obrigatório)">
          <template v-slot:default="{ changeFocus }">
            <textarea
              required
              name="Mensagem"
              @blur="changeFocus(false)"
              @focus="changeFocus(true)"
            ></textarea>
          </template>
        </field>
        <p class="text-center">
          <button type="submit" class="button button-orange">ENVIAR</button>
        </p>
      </form>
         <modal :active.sync="modalContactIsOpen">
        <div class="text-center">
          <h3>Sua mensagem foi enviada com sucesso!</h3>
        </div>
      </modal>
    </div>
  </section>
</template>

<script>
import Field from "./Field";
import api from "../services/api";
import qs from "querystring";
import Modal from "@/components/Modal";

export default {
  components: { Field, Modal },
  props: {
    title: String,
    id: String,
  },

  data() {
    return {
      modalContactIsOpen: false,
       componentKey: 0,
      areas: []
    };
  },

  async created() {
    await this.getAreas();
  },

  methods: {
    
    async submit() {
      // this.loading = true;
      // console.log("dsds");
      try {
        var nome = document.querySelector('[name="Nome"]').value;
        var email = document.querySelector('[name="Email"]').value;
        var telefone = document.querySelector('[name="Telefone"]').value;
        var mensagem = document.querySelector('[name="Mensagem"]').value;


        const requestBody = {
          Nome: nome,
          Email: email,
          Telefone: telefone,
          Mensagem: mensagem
        };

        await api
          .post("report", qs.stringify(requestBody))
          .then(() => {
            this.modalContactIsOpen = true;
            this.componentKey += 1;
          })
          .catch(() => {
            alert(
              "Aconteceu um erro no envio de seu agendamento, Para mais dúvidas, ligue para (11) 3376-0100"
            );
          });
      } finally {
        // this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>
